export default "__VITE_ASSET__5qN3irDv__"